import {objects} from "@atttomyx/shared-utils";

export const hasCompleted = (progress, courseId) => {
    return progress && courseId && progress.courseIds
        && objects.notNullOrUndefined(progress.courseIds[courseId]);
};

export const hasDownloaded = (progress, documentId) => {
    return progress && documentId && progress.documentIds
        && objects.notNullOrUndefined(progress.documentIds[documentId]);
};

export const hasWatched = (progress, videoId) => {
    return progress && videoId && progress.videoIds
        && objects.notNullOrUndefined(progress.videoIds[videoId]);
};

export const hasListenedTo = (progress) => {
    return progress && objects.notNullOrUndefined(progress.music);
};
